export const HEADER_HOOKS = {
  BEFORE_LOGO: 'BEFORE_LOGO',
  AFTER_LOGO: 'AFTER_LOGO',
  BEFORE_NAVIGATION: 'BEFORE_NAVIGATION',
  AFTER_NAVIGATION: 'AFTER_NAVIGATION',
}
